<template>
  <div class="all">
    <div class="header">
      <h1>BLOG<br>部落格</h1>
    </div>
    <section id="section1" class="section1">
      <div class="custom-container">
        <div class="blog-detail">
          <div class="content">
            <h2 class="title">{{title}}</h2>
            <div class="date_back">
              <span class="date">{{formatDate(detail_data.publish_start)}}</span><span class="back" @click="previous">
              <img src="/static/images/blog/back-arrow.svg" alt="" width="16" height="16" style="margin-right:8px">回到上一頁</span></div>
            <hr>
            <div class="article">
              <article v-html="article"></article>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
  import navigation from './navigation.vue';
  export default {
    name: 'Blog-detail',
    components: {
      navigation
    },
    data() {
      return {
        data_count:this.$route.params.id - 1,
        detail_data:[],
        title:'',
        article:'',
      }
    },
    methods:{
      previous(){
        this.$router.go(-1)
      },
      callBlogDetailApi(){
        let vm = this;
        vm.axios({
          method: "get",
          url: process.env.VUE_API_URL + "v1/article/blog",
          params:{
            slug: vm.$route.params.id
          }
        })
        .then(function (response) {
          let res = response.data.data;
          let article = res.trans.editors[0].content;
          vm.detail_data = res
          vm.article = article
          vm.title = res.trans.name
        })
        .catch(function (error) {
          console.log(error)
        })
      },
      formatDate(date) {
        let formatted = new Date(date);
        let year = formatted.getFullYear().toString();
        let month = (formatted.getMonth() + 1).toString();
        let addzero = ("0" + month).slice(-2)
        let day = formatted.getDate().toString();
        return `${year}-${addzero}-${day}`;
      },
    },
    mounted(){
      this.callBlogDetailApi();
    }
  }

</script>

<style lang="scss" scoped>
  @import 'src/assets/scss/blog/detail/header.scss';
  @import 'src/assets/scss/blog/detail/section1.scss';
</style>



// WEBPACK FOOTER //
// src/components/BlogDetail.vue